import React from 'react'
import CalculatorButton from 'features/declaration/form/components/calculator/CalculatorButton'

interface ButtonsContainerProps {
  handleClick: (e: any) => void
}

function ButtonsContainer(props: ButtonsContainerProps) {
  const { handleClick } = props

  return (
    <div className="calculator d-flex justify-content-center">
      <div className="btn-group-vertical" role="group" aria-label="Vertical button group">
        <div className="btn-group btn-group-lg" role="group" aria-label="First Row">
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="AC" value="AC">
            <span>AC</span>
          </CalculatorButton>
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="(" value="(" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name=")" value=")" />
          <CalculatorButton onClick={handleClick} className="btn btn-primary" name="/">
            <i className="fal fa-divide fw-bold" />
          </CalculatorButton>
        </div>
        <div className="btn-group btn-group-lg" role="group" aria-label="First Row">
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="7" value="7" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="8" value="8" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="9" value="9" />
          <CalculatorButton onClick={handleClick} className="btn btn-primary" name="*">
            <i className="fal fa-times fw-bold" />
          </CalculatorButton>
        </div>
        <div className="btn-group btn-group-lg" role="group" aria-label="Second Row">
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="4" value="4" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="5" value="5" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="6" value="6" />
          <CalculatorButton onClick={handleClick} className="btn btn-primary" name="-">
            <i className="fal fa-minus fw-bold" />
          </CalculatorButton>
        </div>
        <div className="btn-group btn-group-lg" role="group" aria-label="Third Row">
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="1" value="1" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="2" value="2" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="3" value="3" />
          <CalculatorButton onClick={handleClick} className="btn btn-primary" name="+">
            <i className="fal fa-plus fw-bold" />
          </CalculatorButton>
        </div>
        <div className="btn-group btn-group-lg" role="group" aria-label="Fourth Row">
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="backspace">
            <i className="fal fa-backspace fw-bold" />
          </CalculatorButton>
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="0" value="0" />
          <CalculatorButton onClick={handleClick} className="btn btn-secondary" name="." value="." />
          <CalculatorButton onClick={handleClick} className="btn btn-primary" name="=" value="=">
            <i className="fal fa-equals fw-bold" />
          </CalculatorButton>
        </div>
      </div>
    </div>
  )
}

export default ButtonsContainer
